import React from 'react';
import '../css/optionsList.css';

import incorrectImg from '../assets/Incorrect choice.png';
import correctImg_branded from '../assets/Correct choice_branded.png';
import correctImg_unbranded from '../assets/Correct choice_unbranded.png';

const OptionsList = ({
  title,
  options,
  handleSubmit,
  submitButtonText,
  selectedOption,
  setSelectedOption,
  wrapperClass,
  allowSubmit,
  bottomText,
  bottomTextClass,
  showAnswer,
  answerIndex,
  optionWrapperStyle,
  customStylesClass
}) => {
  if (!options) return null;
  const correctImg =
    customStylesClass && customStylesClass.includes('unbranded') ? correctImg_unbranded : correctImg_branded;

  // Check for show answer
  // If we are NOT showing, always use selectedoption
  // In the case of Showing and No selected option,. use answer index
  const preCheckSelectedOption = selectedOption === undefined ? answerIndex : selectedOption;
  // console.log(preCheckSelectedOption, selectedOption)

  return (
    <div className="options-wrapper" style={optionWrapperStyle}>
      <h1 className="options-title" dangerouslySetInnerHTML={{ __html: title }} />
      <div className="options-group">
        {options.map((option, index) => (
          <div
            className={`option-wrapper ${wrapperClass} ${customStylesClass ? customStylesClass : ''} ${
              showAnswer && ![answerIndex, preCheckSelectedOption].includes(index) ? 'dim' : ''
            }`}
            key={index}
          >
            <label
              className={`option-label ${showAnswer ? 'show-answer' : ''} ${
                showAnswer && preCheckSelectedOption === index ? 'selected' : ''
              }`}
            >
              <input
                type="radio"
                name="option"
                disabled={!allowSubmit || showAnswer}
                value={index}
                checked={!showAnswer && selectedOption === index}
                onChange={() => setSelectedOption(index)}
              />

              {/* If show answer and question is wrong or right */}

              {showAnswer && [selectedOption].includes(index) ? (
                <img src={answerIndex === index ? correctImg : incorrectImg} alt="answer" />
              ) : (
                <span
                  className={`custom-radio ${customStylesClass ? customStylesClass : ''} ${
                    showAnswer && answerIndex !== selectedOption && index === answerIndex ? 'correct-background' : ''
                  }`}
                >
                  {String.fromCharCode(65 + index)}
                </span>
              )}

              <span>{option}</span>
            </label>
          </div>
        ))}
      </div>

      {allowSubmit && !showAnswer ? (
        <button
          className={`submit-btn ${customStylesClass ? customStylesClass : ''}`}
          onClick={() => handleSubmit()}
          disabled={selectedOption === null}
        >
          {submitButtonText}
        </button>
      ) : null}
    </div>
  );
};

export default OptionsList;
